import type { FC } from 'react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import GettingStarted from '@segment/templates/GettingStarted'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero/Hero'
import BuildPersonalizedChatbots from './components/BuildPersonalizedChatbots'
import DeepenYourUnderstanding from './components/DeepenYourUnderstanding'
import PersonalizedCustomerEngagement from './components/PersonalizedCustomerEngagement'
import ActivateEngagement from './components/ActivateEngagement'
import AIAnnouncements from './components/AIAnnouncements'

import ogImage from './assets/OgImage.png'

const CustomerAIPersonalizationEngine: FC = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout pageTitle="CustomerAI Personalization Engine | Twilio Segment" pageOG={ogImage}>
        <Navigation />
        <Hero />
        <Main>
          <BuildPersonalizedChatbots />
          <DeepenYourUnderstanding />
          <PersonalizedCustomerEngagement />
          <ActivateEngagement />
          <AIAnnouncements />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

export default CustomerAIPersonalizationEngine

const Main = styled.main``
